export class OutOfBoundsNumberOfGuests extends Error {
  constructor() {
    super(
      `Invalid checkout public query: the number of adults, children and/or babies is out of bounds.`,
    );
    Object.setPrototypeOf(this, OutOfBoundsNumberOfGuests.prototype);
  }
}
